import { $gettext } from '@/config/gettext'

const currencies = [
  { code: 'EUR', symbol: '€' }
]

const titles = ['Mr', 'Mrs', 'Miss', 'Chd', 'Inf']
const round = (val) => { return Math.round(val * 100) / 100 }

const customIcons = [
  {
    id: 1,
    label: $gettext('Aquapark'),
    class: 'icon-a-aquapark'
  },
  {
    id: 2,
    label: $gettext('Luxury'),
    class: 'icon-a-luxury'
  },
  {
    id: 3,
    label: $gettext('Air conditioner'),
    class: 'icon-a-air-conditioner'
  },
  {
    id: 4,
    label: $gettext('Coffee machine'),
    class: 'icon-a-coffee-machine'
  },
  {
    id: 5,
    label: $gettext('Recommended by AQUA TOUR'),
    class: 'icon-a-reccommended-by'
  },
  {
    id: 6,
    label: $gettext('Beach vacation'),
    class: 'icon-a-beach-vacantion'
  },
  {
    id: 7,
    label: $gettext('Couple'),
    class: 'icon-a-couple'
  },
  {
    id: 8,
    label: $gettext('For families'),
    class: 'icon-a-family'
  },
  {
    id: 9,
    label: $gettext('For young people'),
    class: 'icon-a-young'
  },
  {
    id: 10,
    label: $gettext('Adults only (12+)'),
    class: 'icon-a-ao-12'
  },
  {
    id: 11,
    label: $gettext('Adults only (13+)'),
    class: 'icon-a-ao-13'
  },
  {
    id: 12,
    label: $gettext('Adults only (14+)'),
    class: 'icon-a-ao-14'
  },
  {
    id: 13,
    label: $gettext('Adults only (16+)'),
    class: 'icon-a-ao-16'
  },
  {
    id: 14,
    label: $gettext('Adults only (18+)'),
    class: 'icon-a-ao-18'
  },
  {
    id: 15,
    label: $gettext('Budget hotel'),
    class: 'icon-a-budget'
  },
  {
    id: 16,
    label: $gettext('Exclusive'),
    class: 'icon-a-exclusive'
  },
  {
    id: 17,
    label: $gettext('VIP'),
    class: 'icon-a-vip'
  },
  {
    id: 18,
    label: $gettext('City hotel'),
    class: 'icon-a-hotel'
  },
  {
    id: 19,
    label: $gettext('Recommended'),
    class: 'icon-a-reccommended'
  },
  {
    id: 20,
    label: $gettext('First line ~ 0-100m'),
    class: 'icon-a-fs-100'
  },
  {
    id: 21,
    label: $gettext('The hotel does not accommodate only men'),
    class: 'icon-a-men-banned'
  },
  {
    id: 22,
    label: $gettext('Wellness programs'),
    class: 'icon-a-wellness'
  },
  {
    id: 23,
    label: $gettext('Accommodates pets'),
    class: 'icon-a-dog'
  },
  {
    id: 24,
    label: $gettext('Does not accommodate pets'),
    class: 'icon-a-dog-banned'
  },
  {
    id: 25,
    label: $gettext('Rooms for disabled people'),
    class: 'icon-a-wheel-chair'
  },
  {
    id: 26,
    label: $gettext('Connecting rooms'),
    class: 'icon-a-connecting-rooms'
  },
  {
    id: 27,
    label: $gettext('Second line ~ 101-300m'),
    class: 'icon-a-fs-300'
  },
  {
    id: 28,
    label: $gettext('Second line ~ 301-600m'),
    class: 'icon-a-sl-600'
  },
  {
    id: 29,
    label: $gettext('Sandy beach'),
    class: 'icon-a-sandy-beach'
  },
  {
    id: 30,
    label: $gettext('Sandy and rocky beach'),
    class: 'icon-a-sandy-rocky'
  },
  {
    id: 31,
    label: $gettext('Rocky beach'),
    class: 'icon-a-rocky-beach'
  },
  {
    id: 32,
    label: $gettext('Water slides'),
    class: 'icon-a-water-slide'
  },
  {
    id: 33,
    label: $gettext('Indoor swimming pool'),
    class: 'icon-a-indoor-pool'
  },
  {
    id: 34,
    label: $gettext('Amusement park'),
    class: 'icon-a-park'
  },
  {
    id: 35,
    label: $gettext('Free Wi-Fi'),
    class: 'icon-a-wifi'
  },
  {
    id: 36,
    label: $gettext('SPA and Welness center'),
    class: 'icon-a-spa-wellness'
  },
  {
    id: 37,
    label: $gettext('SPA hotel'),
    class: 'icon-a-spa'
  },
  {
    id: 38,
    label: $gettext('Indoor swimming pool'),
    class: 'icon-a-indoor-pool'
  },
  {
    id: 39,
    label: $gettext('Heated pool'),
    class: 'icon-a-heated-pool'
  },
  {
    id: 40,
    label: $gettext('Sandy entrance to the sea'),
    class: 'icon-a-sandy-entrance'
  },
  {
    id: 41,
    label: $gettext('Sandy and stony entrance to the sea'),
    class: 'icon-a-sandy-stony-entrance'
  },
  {
    id: 42,
    label: $gettext('Golf course up to 3km'),
    class: 'icon-a-golf'
  },
  {
    id: 43,
    label: $gettext('Kids Club'),
    class: 'icon-a-child'
  },
  {
    id: 44,
    label: $gettext('Evening entertainment'),
    class: 'icon-a-evening'
  },
  {
    id: 45,
    label: $gettext('Fitness'),
    class: 'icon-a-fitness'
  },
  {
    id: 46,
    label: $gettext('Heated pool'),
    class: 'icon-a-heated-pool'
  },
  {
    id: 47,
    label: $gettext('Third line ~ 601-1000m'),
    class: 'icon-a-tl-1000'
  },
  {
    id: 48,
    label: $gettext('Third line ~ 601-1000m'),
    class: 'icon-a-tl-1000'
  }
]

export {
  currencies,
  titles,
  round,
  customIcons
}
